import { FC } from "react"
import { MapPin, Package } from "lucide-react"
import { Card, CardContent } from "../ui/card"

type UnitCardProps = {
  name: string
  abbreviation: string
  binCount?: number
  onClick?: () => void
}

export const UnitCard: FC<UnitCardProps> = ({
  name,
  abbreviation,
  binCount = 0,
  onClick
}) => {
  return (
    <Card
      onClick={onClick}
      className="group cursor-pointer hover:shadow-strong hover:border-sumoPrimary transition-all duration-200 dark:bg-neutral800 dark:border-neutral700"
    >
      <CardContent className="pt-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-lg bg-sumoPrimary/10 dark:bg-sumoPrimary/20 flex items-center justify-center flex-shrink-0">
            <MapPin className="text-sumoPrimary" width={24} height={24} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-lg text-neutral900 dark:text-neutral100 truncate">
              {name}
            </h3>
            <p className="text-xs text-neutral500 dark:text-neutral400 font-mono">
              {abbreviation}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-neutral600 dark:text-neutral400">
          <Package width={14} height={14} />
          <span>
            {binCount} bin{binCount !== 1 ? 's' : ''}
          </span>
        </div>
      </CardContent>
    </Card>
  )
}
